export default __webpack_public_path__ + "static/media/47.2a5404b2.jpeg";